import * as DashboardActions from 'app/actions/dasboard/dashboardActions.ts';
import type { PartialListDialogStatisticDto } from '@/api-gen/api.schemas';
import type { DialogStatisticFull } from 'app/models/statistic/statistic.ts';

export interface IDashboardState {
  dialog?: DialogStatisticFull;
  dialogStatisticsResponse: { isLoading: boolean; dialogStatistics: PartialListDialogStatisticDto; page: number };
  isIntentVerifying: boolean;
}

const initialState: IDashboardState = {
  dialog: undefined,
  dialogStatisticsResponse: { isLoading: false, dialogStatistics: { data: [] }, page: 0 },
  isIntentVerifying: false
};

export const dashboardReducer = (
  state: IDashboardState = initialState,
  action: DashboardActions.Action<DashboardActions.ActionType>
): IDashboardState => {
  switch (action.type) {
    case DashboardActions.ActionType.SetRow: {
      return { ...state, dialog: action.payload.fullDialogStatistic };
    }

    case DashboardActions.ActionType.SetStatisticsLoading: {
      return {
        ...state,
        dialogStatisticsResponse: {
          ...state.dialogStatisticsResponse,
          isLoading: action.payload,
          page: state.dialogStatisticsResponse.page
        }
      };
    }

    case DashboardActions.ActionType.PutDialogStatistics: {
      return {
        ...state,
        dialogStatisticsResponse: {
          ...state.dialogStatisticsResponse,
          dialogStatistics: { ...action.payload },
          page: action.payload.page
        }
      };
    }

    default:
      return state;
  }
};
